export const SUPPORTED_UPDATE_STATUS_CODES = ["E", "X", "P", "PX", "F"];

export const getDefaultStatus = (checkedItems: { result?: string }[], supportedCodes: string[]): string => {
    if (checkedItems.length !== 1) return "";
    const code = checkedItems[0].result;
    if ((code === undefined) || (code === null) || (!supportedCodes.includes(code))) return "";
    return code;
};
